import app from '../../app';
import template from './pageFooter.html';

app.component('pageFooter', { 
    template: template
});